import { useState } from 'react';
import { Outlet, useRouterState } from '@tanstack/react-router';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { clsx } from 'clsx';
import { useAuthStore } from '@/stores/authStore';

export function AppLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const role = useAuthStore(s => s.user?.role);
  const pathname = useRouterState({ select: s => s.location.pathname });
  // Sales executive gets a full-bleed no-padding layout for the call dashboard
  const isSalesFullBleed = role === 'sales_executive' && (pathname === '/' || pathname === '/calls');

  return (
    <div className="flex h-screen overflow-hidden bg-slate-50">
      {/* Desktop Sidebar */}
      <div className="hidden lg:flex shrink-0">
        <Sidebar collapsed={sidebarCollapsed} />
      </div>

      {/* Mobile Sidebar Overlay */}
      {mobileSidebarOpen && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <div className="absolute inset-0 bg-black/40" onClick={() => setMobileSidebarOpen(false)} />
          <div className="relative w-64 h-full">
            <Sidebar collapsed={false} />
          </div>
        </div>
      )}

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header
          onMenuToggle={() => {
            if (window.innerWidth >= 1024) {
              setSidebarCollapsed(!sidebarCollapsed);
            } else {
              setMobileSidebarOpen(true);
            }
          }}
        />
        <main className={clsx('flex-1 overflow-hidden', isSalesFullBleed ? 'flex flex-col' : 'overflow-y-auto')}>
          {isSalesFullBleed ? (
            <div className="flex-1 overflow-hidden h-full">
              <Outlet />
            </div>
          ) : (
            <div className="p-6">
              <Outlet />
            </div>
          )}
        </main>
      </div>
    </div>
  );
}
